import React from 'react'
import Radium from 'radium'

import Link from 'gatsby-link'
import Palette from './assets/palette'
import { HaikuMiniIconSVG, FacebookSVG, TwitterSVG, SlackSVG, YouTubeSVG } from './assets/icons'

const STYLES = {
  section: {
    backgroundColor: Palette.COAL,
    position: 'relative',
    zIndex: 10
  },
  finalStrip: {
    backgroundColor: Palette.FATHER_COAL,
    padding: '13px 45px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 auto'
  },
  aboutText: {
    textAlign: 'left',
    color: Palette.ROCK,
    marginLeft: 19,
    marginTop: -2,
    fontSize: 12
  },
  floatLeft: {
    float: 'left'
  },
  floatRight: {
    float: 'right'
  },
  linksSection: {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'flex',
    padding: '40px 45px 58px',
    transform: 'translateX(35px)',
    '@media screen and (max-width: 860px)': {
      display: 'none'
    }
  },
  column: {
    flexGrow: 1
  },
  title: {
    color: Palette.SUNSTONE,
    marginBottom: 10
  }
}

class Footer extends React.Component {
  constructor() {
    super()

    this.setIconHover = this.setIconHover.bind(this)

    this.state = {
      twitterHovered: false,
      facebookHovered: false,
      slackHovered: false,
    }
  }

  setIconHover(hovered, target) {
    const hoverKey = `${target}Hovered`
    this.setState({ [hoverKey]: hovered })
  }

  render() {
    return (
      <div id="footer" style={STYLES.section}>
        <div style={STYLES.linksSection}>
          <div style={STYLES.column}>
            <h4 style={[STYLES.title, {color: Palette.LIGHTEST_PINK}]}>Company</h4>
            <div><a className="foot-links stash" href={`${process.env.ACCOUNT_SITE_URL}/new`}>Haiku For Mac</a></div>
            <div><a href="/#core" className="foot-links stash">Haiku Core</a></div>
            <div><a href="https://share.haiku.ai" className="foot-links stash">Showcase</a></div>
            <Link className="foot-links stash" to={{ pathname: "/pricing"}}>Pricing</Link>
            <div><Link className="foot-links stash" to={{ pathname: "/blog"}}>Blog</Link></div>
            <div><a className="foot-links stash" href='http://static.haiku.ai.s3.amazonaws.com/brand/Haiku_Media_Kit_v0.3.zip'>Media Kit</a></div>
          </div>
          <div style={STYLES.column}>
            <h4 style={[STYLES.title, { color: Palette.ORANGE }]}>Features</h4>
            <div><a href="/features/#timeline" className="foot-links stash">Timeline</a></div>
            <div><a href="/features/#interactivity" className="foot-links stash">Interactivity</a></div>
            <div><a href="/features/#sharedVersionHistory" className="foot-links stash">Versioning</a></div>
            <div><a href="/features/#haikuCore" className="foot-links stash">Rendering</a></div>
            <div><a href="/features/#haikuCli" className="foot-links stash">Command Line Interface</a></div>
            <div><a href="/features/#crossPlatform" className="foot-links stash">Cross Platform</a></div>
          </div>
          <div style={STYLES.column}>
            <h4 style={[STYLES.title, { color: Palette.LIGHT_BLUE }]}>Integrations</h4>
            <div><a href="/features/#drawing" className="foot-links stash">Sketch</a></div>
            <div><a href="/features/#drawing" className="foot-links stash">Figma</a></div>
            <div><a href="/features/#drawing" className="foot-links stash">Adobe Illustrator</a></div>
            <div><a href="/features/#drawing" className="foot-links stash">SVG</a></div>
            <div><a href="/features/#crossPlatform" className="foot-links stash">React</a></div>
            <div><a href="/features/#crossPlatform" className="foot-links stash">Vue</a></div>
            <div><a href="/features/#crossPlatform" className="foot-links stash">Angular</a></div>
            <div><a href="/features/#crossPlatform" className="foot-links stash">HTML/JS</a></div>
            <div><a href="/features/#crossPlatform" className="foot-links stash">Lottie (iOS, Android)</a></div>
          </div>
          <div style={STYLES.column}>
            <h4 style={[STYLES.title, { color: Palette.PURPLE }]}>Resources</h4>
            <div><a className="foot-links stash" href={`${process.env.ACCOUNT_SITE_URL}/new`}>Download</a></div>
            <div><a className="foot-links stash" target="_blank" rel="noopener" href='https://docs.haiku.ai/release-notes/'>Release Notes</a></div>
            <div><Link className="foot-links stash" to={{ pathname: "/learn/"}}>Learn</Link></div>
            <div><a className="foot-links stash" target="_blank" rel="noopener" href='https://docs.haiku.ai'>Docs</a></div>
            <div><a className="foot-links stash" target="_blank" rel="noopener" href='https://help.haiku.ai/faq-s'>FAQ</a></div>
          </div>
          <div style={STYLES.column}>
            <h4 style={[STYLES.title, { color: Palette.GREEN }]}>Support</h4>
            <Link className="foot-links stash" target ='_blank' to={{ pathname: "/slack-community/"}}>Community Slack</Link>
            <div>
              <a
                className="foot-links stash"
                target='_blank'
                href='https://help.haiku.ai/troubleshooting-and-help'>
                Troubleshooting
              </a>
            </div>
            <div><a className="foot-links stash" href="mailto:contact@haiku.ai?subject=Hello!">Contact</a></div>
            <div>
              <a
                href="/terms-of-service.html"
                className="foot-links stash"
                rel="noopener noreferrer"
                target="_blank">
                Terms of Service
                </a>
            </div>
            <div>
              <a
                href="/privacy-policy.html"
                className="foot-links stash"
                rel="noopener noreferrer"
                target="_blank">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
        <div style={STYLES.finalStrip}>
          <div style={{transform: 'translateY(5px)'}}>
            <div style={STYLES.floatLeft}>
             <a href='/#top'><HaikuMiniIconSVG color={Palette.ROCK} /></a>
            </div>
            <div style={[STYLES.floatLeft, STYLES.aboutText]}>
              <div>© Haiku</div>
              <div>San Francisco, CA</div>
            </div>
          </div>
          <div style={{float: 'right', width: 130}}>
            <a href='https://facebook.com/haikuforteams' target='_blank'
              style={[STYLES.floatRight, {marginLeft: 10, marginTop: 4}]}
              onMouseOver={() => this.setIconHover(true, 'facebook')}
              onMouseOut={() => this.setIconHover(false, 'facebook')}>
              <FacebookSVG color={this.state.facebookHovered ? Palette.LIGHTEST_PINK : Palette.ROCK} />
            </a>
            <a href='https://twitter.com/haikuforteams' target='_blank'
              style={[STYLES.floatRight, {marginLeft: 10, marginTop: 2,}]}
              onMouseOver={() => this.setIconHover(true, 'twitter')}
              onMouseOut={() => this.setIconHover(false, 'twitter')}>
              <TwitterSVG color={this.state.twitterHovered ? Palette.LIGHTEST_PINK : Palette.ROCK} />
            </a>
            <a href='https://www.haiku.ai/slack-community/'
              target='_blank'
              style={[STYLES.floatRight, { marginTop: 4, marginRight: -1, marginLeft: 12 }]}
              onMouseOver={() => this.setIconHover(true, 'slack')}
              onMouseOut={() => this.setIconHover(false, 'slack')}>
              <SlackSVG color={this.state.slackHovered ? Palette.LIGHTEST_PINK : Palette.ROCK} />
            </a>
            <a href='https://www.youtube.com/channel/UCFNlUrip_yGA8Ljk7QcwYog'
              target='_blank'
              style={[STYLES.floatRight, {marginTop: 4, marginRight: -1, width: 24}]}
              onMouseOver={() => this.setIconHover(true, 'youtube')}
              onMouseOut={() => this.setIconHover(false, 'youtube')}>
              <YouTubeSVG color={this.state.youtubeHovered ? Palette.LIGHTEST_PINK : Palette.ROCK} />
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default Radium(Footer)



// WEBPACK FOOTER //
// ./src/components/footer.js